export default __webpack_public_path__ + "static/media/Proreview-5.9ad9f331.jpg";